import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSimpleTableContainer = styled.div``;

const SimpleTableContainer = ({ children, ...other }) => (
  <StyledSimpleTableContainer {...other}>{children}</StyledSimpleTableContainer>
);

SimpleTableContainer.propTypes = {
  /** Displays any kind of content included between opening and closing tags */
  children: PropTypes.node.isRequired,
};

export { SimpleTableContainer, StyledSimpleTableContainer };
